import apiClient from './apiClient'

export interface MCPServer {
  id: number
  name: string
  description?: string
  command: string
  args: string[]
  env_vars?: Record<string, string>
  enabled: boolean
  room: string
  created_at: string
  updated_at: string
}

export interface MCPServerCreateData {
  name: string
  description?: string
  command: string
  args: string[]
  env_vars?: Record<string, string>
  enabled?: boolean
}

export interface MCPServerUpdateData {
  name?: string
  description?: string
  command?: string
  args?: string[]
  env_vars?: Record<string, string>
  enabled?: boolean
}

export const fetchMCPServers = async (roomId: string) => {
  const response = await apiClient.get<MCPServer[]>(
    `/oge/chatbot/rooms/${roomId}/mcp-servers/`
  )
  return response.data
}

export const createMCPServer = async (
  roomId: string,
  data: MCPServerCreateData
) => {
  const response = await apiClient.post<MCPServer>(
    `/oge/chatbot/rooms/${roomId}/mcp-servers/`,
    data
  )
  return response.data
}

export const getMCPServer = async (roomId: string, serverId: number) => {
  const response = await apiClient.get<MCPServer>(
    `/oge/chatbot/rooms/${roomId}/mcp-servers/${serverId}/`
  )
  return response.data
}

export const updateMCPServer = async (
  roomId: string,
  serverId: number,
  data: MCPServerUpdateData
) => {
  const response = await apiClient.patch<MCPServer>(
    `/oge/chatbot/rooms/${roomId}/mcp-servers/${serverId}/`,
    data
  )
  return response.data
}

export const deleteMCPServer = async (roomId: string, serverId: number) => {
  await apiClient.delete(
    `/oge/chatbot/rooms/${roomId}/mcp-servers/${serverId}/`
  )
}

export const getAdvisorMCPServers = async (chatbotId: string) => {
  const response = await apiClient.get<{ mcp_servers: MCPServer[] }>(
    `/oge/chatbot/advisors/${chatbotId}/mcp-servers/`
  )
  return response.data.mcp_servers
}

export const assignMCPServersToAdvisor = async (
  chatbotId: string,
  serverIds: number[]
) => {
  const response = await apiClient.post<{
    message: string
    mcp_servers: MCPServer[]
  }>(`/oge/chatbot/advisors/${chatbotId}/mcp-servers/`, {
    mcp_server_ids: serverIds,
  })
  return response.data
}
